import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { cstToUTCByOffset } from 'yoda-interfaces/lib//Common/CommonHelper';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import { bool } from 'prop-types';
import Timer from './Timer';
import TimerHelper from './TimerHelper';
import { metaDataElement, metaDataProperty } from '../../utils/cmPreviewMetaData';
import { commonAutomationIds } from '../CoreMediaPage/CMPage.config';

const EventTimer = (prop) => {
    const {
        automationId = '',
        eventEndDate = '',
        teaserTitle = '',
        urgencyText = '',
        urgencyTextShowAfterDate = '',
        urlHolder: { value: timerUrl = '', openInNewTab: timerUrlopenInNewTab = false } = {},
        altText = '',
        legalText: {
            legalLinkText = '',
            legalAltText = '',
            urlHolder: { value = '', openInNewTab = false } = {},
        } = {},
        styles: {
            componentCountDownColor = 'e71324',
            componentHeadlineColor = '202020',
            componentUrgencyTextColor = '202020',
        } = {},
        preferences: { offerEndsTextTimer: offerEndsText = 'offer ends' } = {},
        featureFlags: { enableIristzOffset = true } = {},
        isCMPreview,
        cmPreviewDate,
    } = prop;

    const [componentTimerExpired, setcomponentTimerExpired] = useState(false);
    const [isUrgencyDateEnableFromTimer, showUrgencyText] = useState(false);

    const timerWrapperStyle = dt([
        'items-center',
        'flex',
        'justify-center',
        'text-center',
        'flex-column',
        'flex-wrap',
        'md:flex-col',
        'sm:flex-col',
        'lg:flex-row',
    ]);
    const urgencyTextStyle = dt(['mr-2', 'font-sans', 'text-lg', 'font-semibold']);
    const headlineTextStyle = dt(['mr-2', 'font-sans', 'text-lg', 'font-semibold']);
    const offerSectionTextStyle = dt([
        'mr-2',
        'flex',
        'text-xs',
        'font-sans',
        'text-black',
        'justify-center',
        'flex-column',
        'flex-wrap',
    ]);
    const offerEndsTextStyle = dt(['mr-2']);
    const eventEndDateTextStyle = dt(['mr-2']);
    const legalLinkTextStyle = dt(['mr-2']);
    const timeRemainingTextStyle = dt(['mr-2']);
    const legalTextCTAStyle = dt(['mr-2', 'underline']);

    const formattedDate = eventEndDate && eventEndDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
    const formattedYear = formattedDate[1] && formattedDate[1].match(/\d{2}$/);
    const localDateString = `${formattedDate[2]}/${formattedDate[3]}/${formattedYear}`;

    /* istanbul ignore next */
    const getUTCOffsetMinutes = (dateObj) => {
        const input = `${dateObj}`.trim();
        if (/Z$/.test(input)) {
            return 0;
        }
        if (/[+-]\d{2}:\d{2}$/.test(input)) {
            const [hour, min] = input.slice(-6).split(':').map(Number);
            return hour * 60 + min;
        }
        if (/[+-]\d{4}$/.test(input)) {
            const [hour, min] = [input.slice(-4, -2), input.slice(-2)].map(Number);
            return hour * 60 + min;
        }
    };

    const { tzOffset = 300, isPreview = false } = useSelector(({ context = {} }) => context);
    let previewDate = null;
    /* istanbul ignore next */
    if (isPreview || isCMPreview) {
        const selectedDateValue =
            isCMPreview && cmPreviewDate ? cmPreviewDate : Cookies.load('DP_PREVIEW_DATE');
        if (selectedDateValue) {
            const offset = getUTCOffsetMinutes(eventEndDate);
            if (enableIristzOffset && eventEndDate && typeof offset !== 'undefined') {
                previewDate = cstToUTCByOffset(selectedDateValue, -offset);
            } else {
                previewDate = cstToUTCByOffset(selectedDateValue, tzOffset);
            }
        }
    }

    const { total } = TimerHelper.getremainingTimerDetailsData(
        eventEndDate,
        previewDate,
        true,
        false
    );

    const isUrgencyDateEnable =
        urgencyTextShowAfterDate &&
        TimerHelper.fetchUrgencyMessage(previewDate, urgencyTextShowAfterDate);

    const timerHtml = (
        <Timer
            endTime={eventEndDate}
            suffix={false}
            today={previewDate}
            eventBasedTimer
            stickyTimer
            completeCallback={setcomponentTimerExpired}
            showUrgencyText={showUrgencyText}
            urgencyDate={urgencyTextShowAfterDate}
            themeConfig={dt(['font-bold'])}
        />
    );

    if (componentTimerExpired || total < 0) {
        return '';
    }

    const renderTimerComponent = () => {
        return (
            <>
                <div>
                    {(isUrgencyDateEnableFromTimer || isUrgencyDateEnable) && (
                        <span
                            className={urgencyTextStyle}
                            style={{ color: `#${componentUrgencyTextColor}` }}
                            data-cm-metadata={isCMPreview && metaDataProperty('urgencyText')}
                            data-automation-id="at-urgency-text"
                        >
                            {urgencyText}
                        </span>
                    )}
                    <span
                        className={headlineTextStyle}
                        style={{ color: `#${componentHeadlineColor}` }}
                        data-cm-metadata={isCMPreview && metaDataProperty('teaserTitle')}
                        data-automation-id={commonAutomationIds?.MAINTITLE}
                    >
                        {teaserTitle}
                    </span>
                </div>
                <div
                    className={timeRemainingTextStyle}
                    style={{ color: `#${componentCountDownColor}` }}
                    data-automation-id="at-urgency-timer"
                >
                    {timerHtml}
                </div>
                <div className={offerSectionTextStyle} data-automation-id="at-urgency-offer">
                    <div
                        className={offerEndsTextStyle}
                        data-cm-metadata={isCMPreview && metaDataProperty('offerEndsText')}
                    >
                        {offerEndsText}
                    </div>
                    <div
                        className={eventEndDateTextStyle}
                        data-cm-metadata={isCMPreview && metaDataProperty('localDateString')}
                    >
                        {localDateString}
                    </div>
                    <div
                        className={legalLinkTextStyle}
                        data-cm-metadata={
                            isCMPreview && metaDataProperty('legalText.legalLinkText')
                        }
                        data-automation-id={commonAutomationIds?.LEGALTEXT}
                    >
                        <a
                            aria-label="eventtimer-legal-cta"
                            className={legalTextCTAStyle}
                            data-automation-id={commonAutomationIds?.LEGALLINK}
                            href={value}
                            target={openInNewTab ? '_blank' : ''}
                            rel="noreferrer"
                            title={legalAltText}
                        >
                            {legalLinkText}
                        </a>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            {timerUrl ? (
                <a
                    id="timerContainer"
                    aria-label="eventtimer-cta"
                    className={timerWrapperStyle}
                    data-automation-id={automationId}
                    href={timerUrl}
                    target={timerUrlopenInNewTab ? '_blank' : ''}
                    rel="noreferrer"
                    title={altText}
                    data-cm-metadata={isCMPreview && metaDataElement(prop)}
                >
                    {renderTimerComponent()}
                </a>
            ) : (
                <div
                    id="timerContainer"
                    className={timerWrapperStyle}
                    data-automation-id={automationId}
                    data-cm-metadata={isCMPreview && metaDataElement(prop)}
                >
                    {eventEndDate && renderTimerComponent()}
                </div>
            )}
        </>
    );
};
EventTimer.defaultProps = {
    isCMPreview: false,
};
EventTimer.propTypes = {
    isCMPreview: bool,
};
export default EventTimer;
